import './App.css';
import ProductPage from './components/productPage';
import Cart from './components/cart';
import {BrowserRouter, Route, Routes } from 'react-router-dom';
import MainPage from './components/main-page';
import { createContext, useEffect, useState } from 'react';
import LocationPicker from './components/map';
import PaymentPage from './components/payment';
import OrderPlaced from './components/order-placed';
import DisplayProducts from './components/display-products';
import SearchPage from './components/search-page';
import Orders from './components/orders';
import OrderPlacedPage from './components/order-placed-page';
import HamburgerMenu from './components/hamburger-menu';
import PrivacyPolicy from './components/privacy-policy';
import TermsAndConditions from './components/terms-and-conditions';
import ContactUs from './components/contact-us';
import AboutUs from './components/about-us';
import ScrollToTop from './components/scroll-to-top';
import Skeleton from './components/main-page-skelton';
import Coupon from './components/coupon';
import DisplayProductsCategory from './components/display-products-category';
import Login from './components/login';
import OTPVerification from './components/otp-verification';
import AddressList from './components/address-list';
import RequestProduct from './components/requestProduct';
import DeleteAccount from './components/deleteAccount';

export const cartContext = createContext({});

function App() {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

  const [productDataList, setProductDataList] = useState([]);
  const [extraData, setExtraData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [skeleton, setSkeleton] = useState(true);

  const [CartItem, setCartItem] = useState([]);
  const [positionCoords, setPositionCoords] = useState('');
  const [maxAmountReached, setMaxAmountReached] = useState(false);
  const [appliedCoupon, setAppiedCoupon] = useState({});
  const [showPopup, setShowPopUp] = useState(true);


  //installing the web App
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showDownloadButton, setShowDownloadButton] = useState(false);

  useEffect(() => {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      console.log('deferred btn: ', deferredPrompt)
      setShowDownloadButton(true);
    });
  }, []);

  function changeInstallVariable() {
    setDeferredPrompt(null)
    setShowDownloadButton(false)
  }

  useEffect(() => {
    
    const fetchData = async () => {
      try{
        const response = await fetch(`${BACKEND_URL}/get-all-data`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${AUTH_TOKEN}`,  // Send token in header  
          },
        });
        if (!response.ok) {
          setError('Error');
        }
        const data = await response.json()
        const nonZeroList = data.data.productDataList.filter((item) => item.data.quantity !== '0')
        const zeroList = data.data.productDataList.filter((item) => item.data.quantity === '0')
        setProductDataList([...nonZeroList, ...zeroList]);
        setExtraData(data.data.extra);
      } catch (err) {
        console.log(err)
        setError(err);
      } finally {
        // setLoading(false);
        setSkeleton(false)
      }
    }
    fetchData();
    const storedCart = localStorage.getItem('cartItem');
    if (storedCart) {
      setCartItem(JSON.parse(storedCart));
    }
    
  }, [BACKEND_URL]);

  if (skeleton) {
    return (
      <Skeleton />
    );
  }

  if (error) {
    return (
      <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', height:'100vh'}}>
        <img className='loading-img' src='/ontimeurban-logo.png' alt='logo'></img>
        <p style={{ fontSize: '24px', fontWeight: 'bold', fontFamily: 'Arial', color: 'rgb(178, 54, 54)' }}>Something went Wrong!</p>
      </div>
    );
  }
  

  function addToCart(item) {
    setCartItem((prevItem) => {
      const updatedCart = [...prevItem, item];
  
      // Update localStorage with the new cart items
      localStorage.setItem('cartItem', JSON.stringify(updatedCart));
  
      return updatedCart; // Return the updated state
    });
  }

  function clearCart() {
    setCartItem([]);
    setAppiedCoupon({})
    localStorage.removeItem('cartItem');
  }

  function removeFromCart(item) {
    setCartItem((prevItem) => {
      const updatedCart = prevItem.filter(productItem => productItem.details.title !== item.details.title)

      // Update localStorage with the new cart items
      localStorage.setItem('cartItem', JSON.stringify(updatedCart));

      return updatedCart;
    });
  }

  function addPositionCoords(coords) {
    setPositionCoords(coords);
  }

  function changeAppliedCoupon(code, discountPrice) {
    setAppiedCoupon({
      'code': code,
      'discountPrice': discountPrice
    })
  }

  function clearAppliedCoupon() {
    setAppiedCoupon({});
  }

  //set maximum amount reached of a product
  function changeMaxAmountReached(state) {
    setMaxAmountReached(state)
    setTimeout(() => {
      setMaxAmountReached(false)
    }, 1000)
  }

  return (
    <cartContext.Provider value={{CartItem, addToCart, removeFromCart, clearCart, productDataList, extraData, positionCoords, addPositionCoords, maxAmountReached, changeMaxAmountReached, deferredPrompt, showDownloadButton, changeInstallVariable, appliedCoupon, changeAppliedCoupon, clearAppliedCoupon, showPopup, setShowPopUp}}>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route index element={<MainPage />} />
          <Route path='/cart' element={<Cart />} />
          <Route path='/product' element={<ProductPage />} />
          <Route path='/location-picker' element={<LocationPicker />} />
          <Route path='/payment' element={<PaymentPage />} />
          <Route path='/order-placed' element={<OrderPlaced />} />
          <Route path='/display-products' element={<DisplayProducts />} />
          <Route path='/display-products-category' element={<DisplayProductsCategory />} />
          <Route path='/search' element={<SearchPage />} />
          <Route path='/orders' element={<Orders />} />
          <Route path='/order-confirmed' element={<OrderPlacedPage />} />
          <Route path='/hamburger-menu' element={<HamburgerMenu />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
          <Route path='/contact-us' element={<ContactUs />} />
          <Route path='/about-us' element={<AboutUs />} />
          <Route path='/coupon' element={<Coupon />} />
          {/* <Route path='/loginpopup' element={<LoginPopUp />} /> */}
          <Route path='/login' element={<Login />} />
          <Route path='/otp-verification' element={<OTPVerification />} />
          <Route path='/address-list' element={<AddressList />} />
          <Route path='/request-product' element={<RequestProduct />} />
          <Route path='/delete-account' element={<DeleteAccount />} />
        </Routes>
      </BrowserRouter>
    </cartContext.Provider>
  );
}

export default App;
